// extracted by mini-css-extract-plugin
export default {"wrapper":"OmbLGYuMUSr6qRiD5zzP","pageName":"xCbqhpnB4PlayDTPekQX","companyIcon":"WvLTl5iWbCmWy2uX9mTg"};